import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';

export const getPermissions =
    (permissionId, refreshList) =>
      (dispatch) => {
        dispatch({
          type: REDUX_ACTIONS.PERMISSIONS_LIST_LOADING,
        });

        const body = {
          query: {
            permissionId
          }
        };

        const path = 'permissions/fetch';
        return fetch
          .post(path, body)
          .then((resp) => {
            if (!resp.ok) {
              return Promise.reject(resp);
            }
            return resp.json();
          })
          .then((data) => {
            const tableData = Object.entries({ ...data[0]?.details?.permissions })?.map(([email, permissions]) => ({
              email,
              permissions
            }));
            dispatch({
              type: REDUX_ACTIONS.PERMISSIONS_LIST_SUCCESS,
              payload: {
                emailsData: tableData,
                permissions: data[0]
              },
            });
            if (!tableData?.length && refreshList) {
              refreshList();
            }
          })
          .catch(async (error) => {
            const errorMessage = await parseError(error);
            dispatch(
              enqueueSnackbar(
                errorMessage,
                'error',
                new Date().getTime() + Math.random()
              )
            );
            dispatch({
              type: REDUX_ACTIONS.PERMISSIONS_LIST_ERROR,
              payload: { ...error, message: errorMessage },
            });
          });
      };

export const createPermissions =
    (payload, refreshParentDialog) =>
      (dispatch) => {
        dispatch({
          type: REDUX_ACTIONS.PERMISSIONS_LIST_LOADING,
        });

        const body = {
          input: {
            ...payload
          }
        };

        const path = 'permissions/create';
        return fetch
          .post(path, body)
          .then((resp) => {
            if (!resp.ok) {
              return Promise.reject(resp);
            }
            return resp.json();
          })
          .then((data) => {
            dispatch(getPermissions(data?.data));
            refreshParentDialog();
            dispatch(
              enqueueSnackbar(
                'Permission created successfully',
                'success',
                new Date().getTime() + Math.random()
              )
            );
          })
          .catch(async (error) => {
            const errorMessage = await parseError(error);
            dispatch(
              enqueueSnackbar(
                errorMessage,
                'error',
                new Date().getTime() + Math.random()
              )
            );
            dispatch({
              type: REDUX_ACTIONS.PERMISSIONS_LIST_ERROR,
              payload: { ...error, message: errorMessage },
            });
          });
      };

export const editPermissions =
    (payload, permissionId) =>
      (dispatch) => {
        dispatch({
          type: REDUX_ACTIONS.PERMISSIONS_LIST_LOADING,
        });

        const body = {
          query: { permissionId },
          input: {
            ...payload
          }
        };

        const path = 'permissions';
        return fetch
          .put(path, body)
          .then((resp) => {
            if (!resp.ok) {
              return Promise.reject(resp);
            }
            return resp.json();
          })
          .then(() => {
            dispatch(getPermissions(permissionId));
            dispatch(
              enqueueSnackbar(
                'Permission updated successfully',
                'success',
                new Date().getTime() + Math.random()
              )
            );
          })
          .catch(async (error) => {
            const errorMessage = await parseError(error);
            dispatch(
              enqueueSnackbar(
                errorMessage,
                'error',
                new Date().getTime() + Math.random()
              )
            );
            dispatch({
              type: REDUX_ACTIONS.PERMISSIONS_LIST_ERROR,
              payload: { ...error, message: errorMessage },
            });
          });
      };

export const deletePermissions =
    (payload, permissionId, refreshParentDialog) =>
      (dispatch) => {
        dispatch({
          type: REDUX_ACTIONS.PERMISSIONS_LIST_LOADING,
        });

        const body = {
          query: { permissionId },
          input: {
            ...payload
          }
        };

        const path = 'permissions';
        return fetch
          .deleteAction(path, body)
          .then((resp) => {
            if (!resp.ok) {
              return Promise.reject(resp);
            }
            return resp.json();
          })
          .then(() => {
            dispatch(getPermissions(permissionId, refreshParentDialog));
            dispatch(
              enqueueSnackbar(
                'Permission deleted successfully',
                'success',
                new Date().getTime() + Math.random()
              )
            );
          })
          .catch(async (error) => {
            const errorMessage = await parseError(error);
            dispatch(
              enqueueSnackbar(
                errorMessage,
                'error',
                new Date().getTime() + Math.random()
              )
            );
            dispatch({
              type: REDUX_ACTIONS.PERMISSIONS_LIST_ERROR,
              payload: { ...error, message: errorMessage },
            });
          });
      };

export const listWellsUsers = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_LOADING,
  });
  return fetch
    .post('users/fetch/wells')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_SUCESS,
        payload: data.data,
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.PERMISSIONS_WELLS_USERS_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};
